<template>
  <div id="main-content" class="admin-notification-list">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row style="padding-top: 20px">
        <table class="bus-list">
          <tr>
            <th width="8%">#</th>
            <th width="90%">{{ $t('common.title') }}</th>
          </tr>
          <tr v-for="(adminNotification, index) in noticeList" :key="adminNotification.id">
            <td class="notification-no" :class="{ 'is-unread': !adminNotification.is_read }">
              {{ index + 1 }}
              <span class="notification-badge"></span>
            </td>
            <td>
              <div class="text-left ml-5 item-notice" @click="onShowDetailStudent(adminNotification)" v-if="adminNotification.parent && adminNotification.student">
                {{ $t('noticeNewStudent', {fieldParent: adminNotification.parent.name , fieldStudent: adminNotification.student.fullname}) }}
              </div>
            </td>
          </tr>
        </table>
      </el-row>
      <el-row style="padding-top: 20px">
        <el-pagination
            background
            @current-change="didSelectPage"
            :page-size="dataPage.limit"
            layout="prev, pager, next"
            :current-page="page"
            :total="dataPage.total">
        </el-pagination>
      </el-row>
    </el-col>
  </div>
</template>

<script>
import { ITEM_PER_PAGE } from '@/config'
import PageTitle from '@/components/PageTitle'

export default {
  name: 'ListAdminNotification',
  components: {
    PageTitle
  },
  data: function () {
    return {
      backLink: ``,
      title: 'titleListNewStudent',
      page: 1,
      itemPerPage: ITEM_PER_PAGE,
      noticeList: [],
      dataPage: {
        limit: ITEM_PER_PAGE
      }
    }
  },
  methods: {
    didSelectPage: function (e) {
      this.page = e
      this.onGetListNewStudent()
    },
    onGetListNewStudent(){
      let payload = {
        successCallback: (response) => {
          if(response.status ===200){
            this.noticeList = response.data.data.data_list
            this.dataPage = response.data.data
          }
        },
        errorCallback: () => {},
        page: this.page
      }
      this.$store.dispatch('student/getListNewStudent', payload)
    },
    onShowDetailStudent(studentInfo){
      let idParent = studentInfo.parent.id
      let idStudent = studentInfo.student.id
      let payload = {
        successCallback: (response) => {
          if(response.status ===200){
            this.$router.push({path:'/parent/edit', query: {pid: idParent , idStudent}})
            if(studentInfo.is_read === 0){
              this.$store.commit('login/readNotificationListStudent',studentInfo)
            }
          }
        },
        errorCallback: () => {},
        idStudent: studentInfo.id
      }
      this.$store.dispatch('student/onShowStudentNew', payload)

    }
  },
  created: function () {
    this.onGetListNewStudent()
  }
}
</script>
<style lang="scss">
.bus-list {
  width: 100%;
  /*border: 1px solid #DCDFE6;*/

  td, th {
    padding: 5px;
  }
}

table, th, td {
  border: 1px solid #DCDFE6;
  border-collapse: collapse;
}

th {
  height: 55px;
  background-color: rgba(0, 0, 0, 0.2);
  color: #fff;
}

td {
  height: 40px;
}
.item-notice{
  cursor: pointer;
  text-decoration: underline;
  &:hover{
    color: blue;
  }
}

.admin-notification-list{
  .notification-no {
    position: relative;

    .notification-badge {
      width: 10px;
      height: 10px;
      border-radius: 100%;
      position: absolute;
      top: 5px;
      left: 5px;
      background: #ca0000;
      display: none;
    }

    &.is-unread {
      .notification-badge {
        display: block;
      }
    }
  }
}
</style>
